<template>
  <v-card id="order-summary-card" class="px-5 py-5" :class="{ 'sticky-card': true }" :elevation="showCard ? undefined : 0">
    <v-row class="ma-0 pb-3" align="center">
      <h1 class="pa-0">{{ $t('cart.overview.title') }}</h1>
    </v-row>
    <v-row class="ma-0" justify="space-between" align="center">
      <p class="pa-0">{{ $t('cart.overview.products') }}</p><h3 class="pa-0">{{ $currency.formatCurrency(shoppingCart.totalProductPrice) }}</h3>
    </v-row>
    <v-row class="ma-0" justify="space-between" align="center">
      <p class="pa-0">{{ $t('cart.overview.shipping_costs') }}</p><h3 v-if="!loadingShippingCosts" class="pa-0">{{ $currency.formatCurrency(shoppingCart.shippingCost) }}</h3><v-progress-circular v-else indeterminate></v-progress-circular>
    </v-row>
    <v-row class="ma-0 py-3" justify="space-between" align="center">
      <v-divider></v-divider>
    </v-row>
    <v-row class="ma-0" justify="space-between" align="center">
      <p class="pa-0">{{ $t('cart.overview.total') }}</p><h3 class="pa-0">{{ $currency.formatCurrency(shoppingCart.totalPrice) }}</h3>
    </v-row>
    <v-row class="pt-5 ma-0" justify="center" v-if="showButton && buttonText && shoppingCart.products.length > 0">
      <v-btn @click.prevent="onClick" size="large" class="order-summary-checkout-button" block>{{ buttonText }}</v-btn>
    </v-row>
  </v-card>
</template>

<script setup>
const { $currency } = useNuxtApp()
import { useShoppingCartStore } from "@/store/shoppingCart";
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  showCard: {
    type: Boolean,
    default: true,
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  buttonText: {
    type: String,
    default: null,
  },
  loadingShippingCosts: {
    type: Boolean,
    default: false,
  },
  shippingCostsError: {
    type: [null, Error],
    default: null,
  },
});

const emit = defineEmits(['checkout'])

const shoppingCart = useShoppingCartStore()

const headerHeight = ref(0);
const containerPaddingTop = ref(0);
const stickyTopPosition = computed(() => headerHeight.value + containerPaddingTop.value);
let resizeObserver = null;

onMounted(() => {
  // Get header height
  const headerElement = document.querySelector('header');
  if (headerElement) {
    headerHeight.value = headerElement.offsetHeight;

    resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        headerHeight.value = entry.target.offsetHeight;
      }
    });

    resizeObserver.observe(headerElement);
  }

  // Get parent container padding
  const container = document.querySelector('.v-container');
  if (container) {
    const computedStyle = window.getComputedStyle(container);
    containerPaddingTop.value = parseInt(computedStyle.paddingTop, 10);
  }

  // Apply sticky position to card
  updateCardPosition();
  window.addEventListener('resize', updateCardPosition);
});

onUnmounted(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
  window.removeEventListener('resize', updateCardPosition);
});

function updateCardPosition() {
  const card = document.getElementById('order-summary-card');
  if (card && window.innerWidth >= 960) {
    card.style.position = 'sticky';
    card.style.top = `${stickyTopPosition.value}px`;
  } else if (card) {
    card.style.position = '';
    card.style.top = '';
  }
}

async function onClick() {
  emit('checkout')
}
</script>

<style scoped>
.order-summary-checkout-button {
  background-color: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-on-primary)) !important;
}

@media (min-width: 960px) {
  .sticky-card {
    position: sticky;
  }
}
</style>


